import { GrcNotify, NotifyType } from '@grc/ui-package';
import {
  equipmentTypeUrl,
  tenantService
} from '../../common/constants/url-constants';
import notify from '../common/notify';
import I18N from '../../i18n/interface';

type Equipments = {
  tenantId: string;
  fetchData: any;
  localeData: I18N;
};

export default async function GetEquipments({
  tenantId,
  fetchData,
  localeData
}: Equipments) {
  try {
    const response = await fetchData(
      `${equipmentTypeUrl}/${tenantId}/false`,
      notify,
      tenantService
    );
    if (!!response && response.status === 200) {
      const dataArray = Array.isArray(response.data) ? response.data : [];
      return dataArray;
    } else {
      GrcNotify({
        message: 'Failed to fetch equipment type details',
        status: NotifyType.Error
      });
    }
  } catch (error) {
    GrcNotify({
      message: localeData.FailedToFetchEquipmentTypeDetailsNetworkError,
      status: NotifyType.Error
    });
  }
  return [];
}
